<template>
    <div class="grid-wrapper">
        <DxDataGrid ref="grid" :data-source="dxDataSource" @rowDblClick="onRowDblClick"
            @selection-changed="onSelectionChanged" @exporting="onExporting" v-bind="getDefaultGridProperties()">
            <DxSelection mode="single" />
            <DxHeaderFilter :visible="true" />
            <DxFilterRow :visible="true" />
            <DxFilterPanel :visible="true" />
            <DxPaging :enabled="true" :pageSize="10" />
            <DxPager :visible="true" :allowed-page-sizes="[10, 20, 50, 'all']" display-mode="full"
                :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true" />
            <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="true"
                :group-paging="true" />
            <DxExport :enabled="true" />
            <DxColumnChooser :enabled="true" />
            <DxToolbar>
                <DxItem location="after" :caption="$t('sucesos.grid.toolbar.ver_suceso')" template="btnVerSuceso"
                    v-if="tienePermisoSucesosVer(autho)" />
                <DxItem location="after" :caption="$t('sucesos.grid.toolbar.editar_suceso')" template="btnEditarSuceso"
                    v-if="!vistaWiki && tienePermisoSucesosEditar(autho)" />
                <DxItem location="after" :caption="$t('sucesos.grid.toolbar.marcar_revisado')" template="btnMarcarRevisado"
                    v-if="!vistaWiki && tienePermisoSucesosEditar(autho)" />
                <DxItem location="after" :caption="$t('sucesos.grid.toolbar.actualizar_rejilla')"
                    template="btnActualizarRejilla" />
                <DxItem location="after" :caption="$t('sucesos.grid.toolbar.restaurar_rejilla')"
                    template="btnRestaurarRejilla" />
                <DxItem location="after" name="exportButton" />
                <DxItem location="after" name="columnChooserButton" />
            </DxToolbar>
            <DxColumn data-field="NombreCompletoInstalacion" :caption="$t('sucesos.grid.nombre_instalacion')"
                sortOrder="asc" :sortIndex="1" v-if="vistaWiki">
            </DxColumn>
            <DxColumn data-field="FechaHora" :caption="$t('sucesos.grid.fecha_hora')" v-bind="dateTimeDxColumnProps()"
                sortOrder="desc" :sortIndex="0">
            </DxColumn>
            <!-- <DxColumn data-field="NombreSucesoTipo" :caption="$t('sucesos.grid.nombre_suceso_tipo')" sortOrder="asc"
                :sortIndex="2">
            </DxColumn> -->
            <DxColumn data-field="NombreSucesoCategoriaTipo" :caption="$t('sucesos.grid.nombre_suceso_categoria_tipo')"
                sortOrder="asc" :sortIndex="3">
            </DxColumn>
            <DxColumn data-field="TieneFicheroMedidas" :caption="$t('sucesos.grid.tiene_fichero_medidas')"
                cell-template="cellTemplateTieneFicheroMedidas">
            </DxColumn>
            <DxColumn data-field="TieneAdjuntos" cell-template="cellTemplateTieneAdjuntos"
                :caption="$t('sucesos.grid.tiene_adjuntos')">
            </DxColumn>
            <DxColumn data-field="Wiki" :caption="$t('sucesos.grid.wiki')" v-if="!vistaWiki"
                cell-template="cellTemplateTieneWiki">
            </DxColumn>
            <DxColumn data-field="Comentarios" :caption="$t('sucesos.grid.comentarios')">
            </DxColumn>
            <template #btnVerSuceso>
                <DxButton :hint="$t('sucesos.grid.toolbar.ver_suceso')" icon="fa-solid fa-info-circle"
                    styling-mode="text" type="default" @click="verSuceso" :disabled="!hayUnSucesoSeleccionado" />
            </template>
            <template #btnEditarSuceso>
                <DxButton :hint="$t('sucesos.grid.toolbar.editar_suceso')" icon="fa fa-pencil" styling-mode="text"
                    type="default" @click="editarSuceso" :disabled="!hayUnSucesoSeleccionado" />
            </template>
            <template #btnMarcarRevisado>
                <DxButton :hint="$t('sucesos.grid.toolbar.marcar_revisado')" icon="fa-solid fa-check" styling-mode="text"
                    type="default" @click="marcarSucesoRevisado" :disabled="!puedeMarcarComoRevisado" />
            </template>
            <template #btnActualizarRejilla>
                <DxButton :hint="$t('sucesos.grid.toolbar.actualizar_rejilla')" @click="refresh(grid!.instance!)"
                    icon="fa-solid fa-sync" styling-mode="text" type="default" />
            </template>
            <template #btnRestaurarRejilla>
                <DxButton :hint="$t('sucesos.grid.toolbar.restaurar_rejilla')" @click="reset(grid!.instance!)"
                    icon="fa-solid fa-filter-slash" styling-mode="text" type="default" />
            </template>
            <template #cellTemplateTieneFicheroMedidas="{ data }">
                <span :class="obtenerClaseTieneFicheroMedidas((data.data as SucesoDetalleModel).TieneFicheroMedidas)">
                    <i v-if="(data.data as SucesoDetalleModel).TieneFicheroMedidas" class="fa-solid fa-check"></i>
                </span>
            </template>
            <template #cellTemplateTieneAdjuntos="{ data }">
                <span :class="obtenerClaseTieneAdjuntos((data.data as SucesoDetalleModel).TieneAdjuntos)">
                    <i v-if="(data.data as SucesoDetalleModel).TieneAdjuntos"
                        class="fa-solid fa-paperclip-vertical"></i>
                </span>
            </template>
            <template #cellTemplateTieneWiki="{ data }">
                <span :class="obtenerClaseTieneWiki((data.data as SucesoDetalleModel).Wiki)">
                    <i v-if="(data.data as SucesoDetalleModel).Wiki" class="fa-solid fa-check"></i>
                </span>
            </template>
        </DxDataGrid>
    </div>
</template>

<script setup lang="ts">
import {
    DxAsyncRule, DxColumn, DxDataGrid, DxEditing, DxEmailRule, DxFormItem, DxRemoteOperations, DxRequiredRule, DxLookup, DxHeaderFilter, DxFilterRow,
    DxFilterPanel, DxPaging, DxPager, DxCustomRule, DxToolbar, DxItem, DxPopup, DxSelection, DxExport, type DxDataGridTypes, DxColumnChooser
} from "devextreme-vue/data-grid"; import { computed, ref } from "vue";
import { useIntl } from '@services/i18n';
import { DxButton } from "devextreme-vue/button";
import type { SaveSucesoModalModel } from "./Model";
import SaveSucesoModal from "./SaveSucesoModal.vue";
import SucesoRevisadoModal from "./SucesoRevisadoModal.vue";
import { useApi } from '@/.shared/.api/integration';
import type { SucesoDetalleModel } from '@/.shared/.api';
import type CustomStore from "devextreme/data/custom_store";
import { useRouter } from '@/.shared/services/routing-services';
import { useModalService } from "@/.shared/services/modal-service";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { dateTimeDxColumnProps } from "@/.shared/helpers/datetime-field-helper";
import type { RowDblClickEvent, SelectionChangedEvent } from 'devextreme/ui/data_grid';
import { tienePermisoSucesosEditar, tienePermisoSucesosVer } from "@/.shared/helpers/permission-helper";
import { refresh, reset, exportToExcel, getDefaultGridProperties, getSelectedRow } from "@/.shared/helpers/grid-helper";

const props = defineProps<{ dxDataSourceProp: CustomStore | undefined, vistaWikiProp: boolean }>();
const dxDataSource = computed(() => props.dxDataSourceProp);
const vistaWiki = computed(() => props.vistaWikiProp);

const api = useApi();
const intl = useIntl();
const router = useRouter();
const modalService = useModalService();
const autho = useAuthorization();

const grid = ref<DxDataGrid>();
let sucesoSeleccionado = ref<SucesoDetalleModel>();
let idSucesoSeleccionado = computed(() => sucesoSeleccionado.value?.Id); // computed = function que devuelve algo. watch = function que no devuelve nada (void).
let hayUnSucesoSeleccionado = computed(() => sucesoSeleccionado.value != null);
let puedeMarcarComoRevisado = computed(() => {
    if (!sucesoSeleccionado.value) return false;
    const suceso = sucesoSeleccionado.value;
    const fc = suceso.FechaCreacion;
    const fum = suceso.FechaUltimaModificacion;
    // Comparar fechas usando getTime() porque son objetos Date diferentes en memoria
    if (fc instanceof Date && fum instanceof Date) {
        return fc.getTime() === fum.getTime();
    }
    return fc === fum;
});

function onRowDblClick(e: RowDblClickEvent): void {
    if (tienePermisoSucesosVer(autho)) {
        let suceso = e.data as SucesoDetalleModel;
        irADetalleSuceso(suceso.Id);
    }
}

function onSelectionChanged(e: SelectionChangedEvent): void {
    sucesoSeleccionado.value = e.selectedRowsData[0];
}

function onExporting(e: DxDataGridTypes.ExportingEvent): void {
    exportToExcel(e, 'Sucesos');
}

async function verSuceso(): Promise<void> {
    if (hayUnSucesoSeleccionado.value)
        irADetalleSuceso(idSucesoSeleccionado.value!);
}

function irADetalleSuceso(idSucesoSeleccionado: number): void {
    router.push(intl.i18Route({ name: "suceso-detalle-view", params: { id: idSucesoSeleccionado } }));
}

async function editarSuceso(): Promise<void> {
    if (hayUnSucesoSeleccionado.value) {
        const suceso = sucesoSeleccionado.value!;
        const sucesoEdit: SaveSucesoModalModel = {
            Id: suceso.Id,
            IdSucesoTipo: suceso.IdSucesoTipo,
            IdSucesoCategoriaTipo: suceso.IdSucesoCategoriaTipo,
            Wiki: suceso.Wiki,
            Comentarios: suceso.Comentarios,
            Adjuntos: [],
            AdjuntosExistentes: suceso.Adjuntos
        };

        const result = await modalService.showModal(SaveSucesoModal, { sucesoProp: sucesoEdit }, { title: intl.i18n.t('sucesos.grid.boton_editar_suceso'), maxWidth: "600", maxHeight: "70vh" });
        if (result) {
            const dxDataGrid = grid.value!.instance!;
            await refresh(dxDataGrid);
            const suceso = await getSelectedRow(dxDataGrid) as SucesoDetalleModel;
            sucesoSeleccionado.value = suceso;
        }
    }
}

async function marcarSucesoRevisado(): Promise<void> {
    if (puedeMarcarComoRevisado.value && hayUnSucesoSeleccionado.value) {
        const result = await modalService.showModal(SucesoRevisadoModal, { idSuceso: idSucesoSeleccionado.value! }, { title: intl.i18n.t('sucesos.grid.toolbar.marcar_revisado'), width: 480, height: "auto", showCloseButton: false });
        if (result) {
            const dxDataGrid = grid.value!.instance!;
            await refresh(dxDataGrid);
            // Actualizar la selección después del refresh
            const suceso = await getSelectedRow(dxDataGrid) as SucesoDetalleModel;
            sucesoSeleccionado.value = suceso;
        }
    }
}

function obtenerClaseTieneFicheroMedidas(tieneFicheroMedidas: boolean): string {
    return tieneFicheroMedidas ? "suceso--tiene-fichero-medidas" : "suceso--no-tiene-fichero-medidas";
}

function obtenerClaseTieneAdjuntos(tieneFicheroMedidas: boolean): string {
    return tieneFicheroMedidas ? "suceso--tiene-adjuntos" : "suceso--no-tiene-adjuntos";
}

function obtenerClaseTieneWiki(tieneWiki: boolean): string {
    return tieneWiki ? "suceso--tiene-wiki" : "suceso--no-tiene-wiki";
}
</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

span.suceso--tiene-fichero-medidas,
span.suceso--tiene-adjuntos,
span.suceso--tiene-wiki {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

span.suceso--tiene-fichero-medidas i,
span.suceso--tiene-adjuntos i,
span.suceso--tiene-wiki i {
    font-size: 1rem;
    color: var(--icon-primary-default)
}
</style>